import { render, staticRenderFns } from "./DocumentTemplate.vue?vue&type=template&id=3df39359&scoped=true"
import script from "./DocumentTemplate.vue?vue&type=script&lang=js"
export * from "./DocumentTemplate.vue?vue&type=script&lang=js"
import style0 from "./DocumentTemplate.vue?vue&type=style&index=0&id=3df39359&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df39359",
  null
  
)

export default component.exports